import { ArticleTextMessage } from './ArticleTextMessage';

export default ArticleTextMessage;
